import { plainText } from '../icons/rich';
import { h } from './dom';
import type { Settings } from './Phone';

/** The settings controls (volume sliders and switches), shared by the phone and the start screen. */
export function settingsControls(current: Settings, onChange: (s: Settings) => void): HTMLElement[] {
  const set = { ...current };
  const slider = (label: string, key: 'music' | 'sfx'): HTMLElement => {
    const input = h('input', {
      attrs: {
        type: 'range',
        min: '0',
        max: '1',
        step: '0.05',
        value: String(set[key]),
        'aria-label': plainText(label),
      },
    });
    input.addEventListener('input', () => {
      set[key] = Number(input.value);
      onChange({ ...set });
    });
    return h('div', { class: 'setting' }, h('label', { text: label }), input);
  };
  const check = (label: string, key: 'shadows' | 'sway' | 'firstPerson' | 'invertY'): HTMLElement => {
    const input = h('input', { attrs: { type: 'checkbox' } });
    input.checked = set[key];
    input.addEventListener('change', () => {
      set[key] = input.checked;
      onChange({ ...set });
    });
    return h(
      'label',
      { class: 'setting check', style: { display: 'flex', gap: '8px', alignItems: 'center' } },
      input,
      label,
    );
  };
  return [
    slider(':banjo: Music volume', 'music'),
    slider(':speaker: Sound effects volume', 'sfx'),
    check('Shadows (turn off for potato PCs)', 'shadows'),
    check('Drunk camera sway', 'sway'),
    check('First-person view (V, or scroll all the way in)', 'firstPerson'),
    check('Invert Y axis (look up/down)', 'invertY'),
  ];
}
